<template>
  <div class="insights-navigation-list">
    <InsightsNavigationListCard
      v-for="user in users"
      :key="user.id"
      :item="user"
      :type="type"
      :active="userId === user.id"
      :team-id="teamId"
    />
    <div v-if="loading">
      <InsightsNavigationListCardLoading
        v-for="i in defaultItemsLoading"
        :key="i"
      />
    </div>
    <div
      v-else
      :class="`load-more ${type}-load-more`"
    />
    <InsightsNavigationListEmpty
      v-if="empty"
      :type="type"
      :item-id="currentDashboardId"
      :individual="isIndividualTeamDashboard"
    />
    <div :style="hubspotStyle" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import InsightsNavigationListCard from '~/components/insights/InsightsNavigationListCard.vue';
import InsightsNavigationListCardLoading from '~/components/insights/InsightsNavigationListCardLoading.vue';
import InsightsNavigationListEmpty from '~/components/insights/InsightsNavigationListEmpty.vue';
import { INSIGHTS } from '~/app_constants';
import { InsightsResource } from '~/resources';

export default {
  name: 'InsightsNavigationLazyList',
  components: {
    InsightsNavigationListCard,
    InsightsNavigationListCardLoading,
    InsightsNavigationListEmpty,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    teamId: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    observer: null,
    loading: null,
    defaultItemsToShow: INSIGHTS.perPage,
    defaultItemsLoading: 9,
    page: 1,
  }),
  computed: {
    ...mapState(['hubspot_enabled']),
    ...mapState({
      users: (state) => state.users.users || [],
      organizationId: (state) => state.organization.id,
    }),
    ...mapGetters(['filters', 'loadingUsers', 'currentDashboardId', 'isIndividualTeamDashboard']),
    userId() {
      return this.filters.user_id;
    },
    hubspotStyle() {
      return this.page === null && this.hubspot_enabled && { paddingBottom: '50px' };
    },
    empty() {
      return this.loading === false && this.users.length === 0;
    },
  },
  watch: {
    teamId: 'refetchMembers',
    userId: 'refetchMembers',
  },
  updated() {
    this.addObserver();
  },
  mounted() {
    this.fetchMembers();
  },
  beforeUnmount() {
    this.observer?.disconnect();
  },
  methods: {
    ...mapActions(['setPaginatedUsers', 'fetchEngagementScores']),
    fetchMembers() {
      const page = this.page;

      if (!page) {
        return;
      }
      this.loading = true;

      InsightsResource.members(
        { organizationId: this.organizationId },
        { page, team_id: this.teamId, selection: [this.userId] },
        {
          abortReload: true,
        },
      ).then((result) => {
        this.setPaginatedUsers({ users: result.items, page });
        this.page = result.pagination.next_page;
        this.$nextTick(() => {
          this.fetchEngagementScores({ users: result.items });
          this.loading = false;
        });
      });
    },
    refetchMembers() {
      this.page = 1;
      this.setPaginatedUsers({ users: [], page: this.page });
      this.$el.closest('.app-accordion-content').scrollTo(0, 0);
      this.fetchMembers();
    },
    addObserver() {
      const target = document.querySelector(`.${this.type}-load-more`);

      if (target) {
        this.observer = new IntersectionObserver(this.handleIntersect, { root: null, threshold: 0.5 });
        this.observer.observe(target);
      }
    },
    handleIntersect(entries) {
      if (entries[0].isIntersecting && !this.loading) {
        this.fetchMembers();
      }
    },
  },
};
</script>
